import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { r } from '../../../shared/lib/responsive';

export const Card = styled.article<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: var(--card-padding-top) var(--card-padding-right) var(--card-padding-bottom)
    var(--card-padding-left);
  border-radius: var(--radius-card);
  backdrop-filter: var(--effect-glass-blur);
  -webkit-backdrop-filter: var(--effect-glass-blur);
  transition: opacity 0.35s ease, box-shadow 0.35s ease;

  ${(p) =>
    p.$active
      ? css`
          ${r('width', 189)}
          ${r('height', 274)}
          gap: var(--card-gap-active);
          background: var(--color-card-active);
          box-shadow: var(--shadow-card-active);
        `
      : css`
          ${r('width', 172)}
          ${r('height', 250)}
          gap: var(--card-gap-inactive);
          background: var(--color-card-inactive);
          opacity: 0.85;
        `}
`;

export const ImageWrap = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  border-radius: var(--radius-card-img);
  overflow: hidden;
  background: var(--color-card-img-fallback);
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  -webkit-user-drag: none;
  user-select: none;
  pointer-events: none;
`;

export const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: var(--color-card-img-fallback);
  color: #888888;
  ${r('font-size', 13)}
  text-align: center;
`;

export const Name = styled.p<{ $active: boolean }>`
  margin: 0;
  text-align: center;
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-tight);
  line-height: 1.2;

  ${(p) =>
    p.$active
      ? css`
          font-size: var(--type-menu-name-active-size);
          color: var(--color-text-menu-active);
        `
      : css`
          font-size: var(--type-menu-name-inactive-size);
          color: var(--color-text-menu);
        `}
`;
